import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GetSingleCoupon,
  UpdateCoupon as UpdateSingleCoupon,
} from "../../../services/coupons";
import CouponForm from "../../../forms/Coupons";
import useBundlesStore from "../../../store/bundle";
import { GetBundles } from "../../../services/bundle";

const UpdateCoupon = () => {
  const [coupon, setCoupon] = useState(null);
  const { id } = useParams();
  const { bundles, setBundles } = useBundlesStore();
  const [currentPage, setCurrentPage] = useState(1);

  const fetchBundles = async () => {
    if (!bundles.length) {
      const { data } = await GetBundles(currentPage);
      if (data?.result) {
        setBundles(data.result);
      }
    }
  };

  const fetchCoupon = async () => {
    const coupon = await GetSingleCoupon(id);
    if (coupon.data.result) {
      setCoupon(coupon.data.result);
    }
  };

  useEffect(() => {
    if (id) {
      fetchCoupon();
      fetchBundles();
    }
  }, [id]);

  const handleSubmit = (payload) => {
    return UpdateSingleCoupon(id, payload);
  };
  return (
    <>
      {coupon ? (
        <CouponForm
          key={"update-coupon"}
          coupon={coupon}
          heading={"Update Coupon"}
          onSubmit={handleSubmit}
        />
      ) : (
        // <BundleForm
        //   isSearching={isSearching}
        //   searchProduct={fetchProducts}
        //   onSubmit={handleSubmit}
        //   key={"create-bundle"}
        //   bundle={bundle}
        //   categories={categories}
        //   boxes={boxes}
        //   form={""}
        //   productPage={currentProductPage}
        //   setProductPage={setCurrentPage}
        //   heading={"Update bundle"}
        // />
        ""
      )}
    </>
  );
};

export default UpdateCoupon;
